import React, {useState} from "react";


import {Text, View, StyleSheet, Image, TextInput, TouchableOpacity, ActivityIndicator, ScrollView , Modal} from 'react-native';

import Config from "../../../Config";
import SliderHome from "../../Components/SliderHome";

import axios from "axios";
import { RFPercentage, RFValue } from "react-native-responsive-fontsize";
import {useFocusEffect, useNavigation} from "@react-navigation/native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import toast from "../../Components/Toast";
import {FontAwesome} from "@expo/vector-icons";
import SliderHome2 from "../../Components/SliderHome2";



import * as ScreenOrientation from 'expo-screen-orientation';


import AntDesign from "@expo/vector-icons/AntDesign";


import * as Speech from 'expo-speech';


const HomeTab = ({stack})=>{
    React.useEffect(() => {

        const speak = () => {
            const thingToSay = 'Hello , Welcome to Himora! ';
            // const thingToSay = 'The subject of the sentence is The cat  ';
            Speech.speak(thingToSay, {
                pitch: 1.1,        // تُن صدا
                rate: 0.6,         // سرعت گفتار (۰.۱ تا ۲.۰)
            });
        };
        speak();
       // getHome();
    },[]);


    useFocusEffect(
        React.useCallback(() => {
            async function changeScreenOrientation() {
                // await ScreenOrientation.unlockAsync();
                await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT);
            }
            changeScreenOrientation();
            getHome();
            return () => {
            };
        }, [])
    );



    const navigation = useNavigation();

    let [data, setData] = useState(false);
    let [notifmodal, setNotifmodal] = useState(false);



    let opennotifmodal = async ()=>{
        setNotifmodal(true);
        let token = await AsyncStorage.getItem('token');
        let res = await axios.get(`${Config.api}/user/notifseen`,{ 'headers': {  Authorization: 'Bearer '+token} });
        console.log(res.data);
    }

    let getHome = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/home`,{ 'headers': {  Authorization: 'Bearer '+token} });
            if(res.data.code != 1){
                await AsyncStorage.removeItem('token');
                toast('خطا در احراز هویت');
                navigation.push('Splash');
            }else{
                setData( res.data);
                if(res.data.not_seen_all == 1){
                    await opennotifmodal();
                }
            }
        } catch (err) {
           alert('خطا ! لطفا اتصال اینترنت خود را بررسی کنید .');
           console.log(err)
        }
    }



    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <Image
                    resizeMode={'stretch'}
                    fadeDuration={999}
                    style={{
                        width : RFValue(90),
                        height :RFValue(20),

                    }}
                    source={require('../../../assets/images/logo.png')}
                />



                {data &&
                    <>
                    {data.notif  == 1 ?

                        <TouchableOpacity   onPress={()=>navigation.navigate('Tickets')}>

                            <Image

                                resizeMode={'stretch'}
                                fadeDuration={999}
                                style={{
                                    width : RFValue(20),
                                    height :RFValue(20),

                                }}
                                source={require('../../../assets/images/bell.png')}
                            />

                        </TouchableOpacity>
                        :
                        <>
                            {data.not_seen_all == 1 ?
                                <TouchableOpacity   onPress={()=>opennotifmodal(true)}>
                                    <Image
                                        resizeMode={'stretch'}
                                        fadeDuration={999}
                                        style={{
                                            width : RFValue(20),
                                            height :RFValue(20),

                                        }}
                                        source={require('../../../assets/images/bell.png')}
                                    />
                                </TouchableOpacity>
                                :
                                <FontAwesome  onPress={()=>opennotifmodal(true)} name="bell-o" size={RFValue(20)} color="white" />
                            }
                        </>

                    }

                    </>

                }


            </View>


            {data   &&
                <>
                    <Modal
                        animationType="slide" // Options: 'none', 'slide', 'fade'
                        transparent={true} // Makes background transparent
                        visible={notifmodal}
                        onRequestClose={() => setNotifmodal(false)} // Handles Android back button
                    >
                        <View style={styles.modalContainer}>
                            <View style={styles.modalView}>
                                <View style={styles.modalheader}>
                                    <Text style={styles.modaltextheader}>اطلاعیه ها</Text>
                                    <AntDesign onPress={()=>setNotifmodal(false)} name="close" size={24} color="#8C8C8C" />
                                </View>
                                <ScrollView showsVerticalScrollIndicator={false}>
                                    {data.notifications.map((item,index)=>
                                        <View style={styles.modalbox} key={index}>
                                            <View style={{flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
                                                <Text style={styles.titlenotif}>
                                                    {item.title}
                                                </Text>
                                                <Text style={styles.datenotif}>
                                                    {item.date}
                                                </Text>
                                            </View>
                                            <Text style={styles.desnotif}> {item.des}</Text>
                                        </View>
                                    )}
                                </ScrollView>


                            </View>
                        </View>
                    </Modal>
                    <ScrollView style={{flex : 1}}>
                        {/*<SliderHome navigation={navigation} slider={data.slider} />*/}
                        <SliderHome2 navigation={navigation} slider={data.slider} />

                        <View style={styles.hr}></View>


                        <View style={styles.category}>
                            <Text style={styles.categorytext}>
                                دستـــه بنــدی دوره هــا
                            </Text>
                        </View>
                        <TouchableOpacity   onPress={()=>navigation.navigate('Packs')}>
                            <Image
                                resizeMode={'stretch'}
                                fadeDuration={999}
                                style={{
                                    width : '90%',
                                    // width : RFValue(285),
                                    height :RFValue(155),
                                    borderRadius : RFValue(15),
                                    marginHorizontal : '5%',
                                    marginVertical : RFValue(15),

                                }}
                                source={{uri : `${data.banner}`}}
                            />
                        </TouchableOpacity>

                        <View style={styles.categories}>
                            {data.category.map( (item,index) =>
                                <TouchableOpacity key={index} style={styles.item}  onPress={()=>stack.navigate('CategoryGroup',{
                                    category_id: item.id,
                                })} >
                                    <Image   transition={9000} style={styles.image} source={{uri : `${Config.base}/${item.picture}`}} />
                                    <Text style={styles.itemtext}>{item.ename}</Text>
                                    <Text style={styles.itemtext}>{item.name}</Text>
                                </TouchableOpacity>
                            )}

                        </View>

                    </ScrollView>
                </>

            }


        </View>




    );
}


export default HomeTab;



const styles = StyleSheet.create({

    categories : {
        flexDirection : 'row',
        flexWrap : 'wrap',

        justifyContent : 'space-between',
        paddingHorizontal : RFValue(20),
        paddingVertical : RFValue(30),
    },
    item : {
        justifyContent : 'center',
        alignItems: 'center',
        paddingHorizontal : RFValue(14),
        paddingVertical : RFValue(20),
    },
    image : {
        width: RFValue(105),
        height: RFValue(105),
        borderRadius :100,
    },
    itemtext : {
        fontFamily : 'yk',
        color : 'white',
        fontSize : RFValue(14),
        marginTop : RFValue(14),
    },

    hr : {
        borderWidth : 1,
        borderColor : '#44486E',
        marginVertical : RFValue(20),
    },

    category: {
        justifyContent: "center",
        alignItems: "center",
    },
    categorytext: {
        fontFamily : 'ykb',
        color : '#fff',
        fontSize : RFValue(16),
        // fontWeight : "bold"
    },

    header: {
        flexDirection : 'row',
        justifyContent : 'space-between',
        paddingHorizontal : RFValue(20),
        paddingVertical : RFValue(30),
    },


    container: {
        flex: 1,
        backgroundColor : Config.maincolor,
    },

    modalContainer: {
        flexGrow : 1,
        // justifyContent : 'center',
        alignItems: 'center',
    },
    modalView: {
        backgroundColor : 'white',
        width: '85%',
        maxHeight : RFValue(210),
        borderRadius : RFValue(10),
        marginTop : RFValue(65),
        padding : RFValue(15),
    },
    modalheader : {
        flexDirection : 'row',
        justifyContent : 'space-between',
        alignItems: 'center',
        paddingVertical : RFValue(5),
    },
    modaltextheader : {
        fontFamily : 'ykb',
        color : '#000',
        fontSize : RFValue(16),

    },
    titlenotif : {
        fontFamily : 'ykb',
        color : '#000',
        fontSize : RFValue(13),

    },
    desnotif : {
        fontFamily : 'yk',
        color : '#8C8C8C',
        fontSize : RFValue(11),
        marginVertical : RFValue(8),

    },
    datenotif : {
        fontFamily : 'yk',
        color : '#8C8C8C',
        fontSize : RFValue(11),
    },
    modalbox : {
      borderTopColor : '#E7E9F2',
      borderTopWidth : 1,
        paddingTop : RFValue(15),
    },
})